import React from 'react'
import loading from '../images/loading4.gif'

const Spinner = () => {
    return (
        <>
            <div className='text-center my-3'>
                <img src={loading} alt="Loading" width={"525px"} />
            </div>
        </>
    )
}

export default Spinner